<div class="row">
  <div class="col-xs-12 d-md-none d-sm-block">
    <div class="gt-logo-mobile">
      <img
        ngSrc="../../../assets/images/Guard_Tracker-Stacked-{{
          currentTheme
        }}.avif"
        alt="Guard Tracker"
        width="160"
        height="160"
        priority
        as="image"
      />
    </div>
  </div>
  <div class="col-xs-12 d-none d-md-block p-5 mb-3">
    <div class="gt-logo-desktop">
      <img
        ngSrc="../../../assets/images/Guard_Tracker-Stacked-{{
          currentTheme
        }}.avif"
        alt="Guard Tracker"
        width="160"
        height="160"
        priority
        as="image"
      />
    </div>
  </div>
</div>

<div class="gt-p-1">
  <div class="container gt-auth-block">
    @if (showErrorMsg) {
      <div
        class="alert alert-warning alert-dismissible fade show text-center"
        role="alert"
      >
        {{ showErrorMsg }}
      </div>
    }
    @if (showSuccessMsg) {
      <div
        class="alert alert-light alert-dismissible fade show text-center"
        role="alert"
      >
        {{ showSuccessMsg }}
      </div>
    }
    @if (s3FileInfo?.file_url) {
      <div
        class="alert alert-light alert-dismissible fade show text-center"
        role="alert"
      >
        Download should begin automatically. If not, tap
        <a [href]="s3FileInfo?.file_url" download>here</a> to start the
        download.
      </div>
    }
  </div>
</div>
